/**
 * 配置文件
 * @author xuxiaoyan
 */

import { isIOS, isAndroid } from './util'

export const passengerConfig = {
  /**
   * 初始化右上角更多按钮
   */
  initEntrance: {
    fn: 'init_entrance'
  },
  /**
   * 唤起更多按钮
   */
  invokeEntrance: {
    fn: 'invoke_entrance'
  },
  /**
   * 展示更多按钮
   */
  showEntrance: {
    fn: 'show_entrance'
  },
  /**
   * 隐藏更多按钮
   */
  hideEntrance: {
    fn: 'hide_entrance'
  },
  /**
   * 分享到微信朋友圈
   */
  shareWeixinTimeline: {
    fn: 'share_weixin_timeline'
  },
  /**
   * 分享到微信
   */
  shareWeixinAppmsg: {
    fn: 'share_weixin_appmsg'
  },
  /**
   * 分享到支付宝朋友圈
   */
  shareAlipayLife: {
    fn: 'share_alipay_life'
  },
  /**
   * 分享给支付宝好友
   */
  shareAlipayFriend: {
    fn: 'share_alipay_friend'
  },
  /**
   * 分享到QQ空间
   */
  shareQzone: {
    fn: 'share_qzone'
  },
  /**
   * 分享到QQ
   */
  shareQqAppmsg: {
    fn: 'share_qq_appmsg'
  },
  /**
   * 分享到新浪微博
   */
  shareSinaWeibo: {
    fn: 'share_sina_weibo'
  },
  /**
   * 获取用户信息
   */
  getUserInfo: {
    fn: 'getUserInfo'
  },
  /**
   * 获取系统信息
   */
  getSystemInfo: {
    fn: 'getSystemInfo'
  },
  /**
   * 获取地理位置信息
   */
  getLocationInfo: {
    fn: 'getLocationInfo'
  },
  /**
   * 获取apollo接口
   */
  apolloGetToggle: {
    fn: 'apolloGetToggle'
  },
  /**
   * 刷新页面
   */
  refreshPage: {
    fn: 'page_refresh'
  },
  /**
   * 关闭页面
   */
  closePage: {
    fn: 'page_close'
  },
  /**
   * 打开页面
   */
  openPage: {
    fn: 'openNativeWebPage'
  },
  // /**
  //  * 微信支付
  //  */
  // payByWX: {
  // 	fn: 'payByWX'
  // },
  // /**
  //  * 支付宝支付
  //  */
  // payByAli: {
  // 	fn: 'payByAli'
  // },
  /**
   * 请求登录
   */
  requestLogin: {
    fn: 'callNativeLoginWithCallback'
  },
  /**
   * 设置title
   */
  setTitle: {
    fn: 'updateNaviTitle'
  },
  // /**
  //  * 获得联系人信息
  //  */
  // getContacts: {
  // 	fn: 'getContacts'
  // }
}

export const driverConfig = {
  weixinAppmsg: {
    fn: 'weixinAppmsg',
    support: '2.4.4',
    prepare: function(name, config, fn) {
      var conf = {
        url: config.url || config.share_url,
        icon: config.icon || config.icon_url || config.share_icon_url || config.imageUrl,
        title: config.title || config.share_title,
        desc: config.desc || config.content || config.share_content || config.descript
      }, cfg

      if(isIOS) {
        cfg = {
          share_url: conf.url,
          share_icon_url: conf.icon,
          share_title: conf.title,
          share_content: conf.desc
        }
        return ['share_weixin_appmsg', JSON.stringify(cfg), function() {}]
      } else if(isAndroid) {
        cfg = {
          url: conf.url,
          imageUrl: conf.icon,
          title: conf.title,
          descript: conf.desc,
          isFriendCircle: false
        }
        return ['callWXShare', cfg, function() {}]
      }
    }
  },
  weixinTimeline: {
    fn: 'weixinTimeline',
    support: '2.4.4',
    prepare: function(name, config, fn) {
      var conf = {
        url: config.url || config.share_url,
        icon: config.icon || config.icon_url || config.share_icon_url || config.imageUrl,
        title: config.title || config.share_title,
        desc: config.desc || config.content || config.share_content || config.descript
      }, cfg

      if(isIOS) {
        cfg = {
          share_url: conf.url,
          share_icon_url: conf.icon,
          share_title: conf.title,
          share_content: conf.desc
        }
        return ['share_weixin_timeline', JSON.stringify(cfg), function() {}]
      } else if(isAndroid) {
        cfg = {
          url: conf.url,
          imageUrl: conf.icon,
          title: conf.title,
          descript: conf.desc,
          isFriendCircle: true
        }
        return ['callWXShare', cfg, function() {}]
      }
    }
  },
  shareSms: {
    fn: 'share_sms',
    support: '2.4.4'
  },
  initEntrance: {
    fn: 'init_entrance',
    support: '2.4.4'
  },
  hideEntrance: {
    fn: 'hide_entrance',
    support: [{type: 'android', version: '2.4.4'}]
  },
  showEntrance: {
    fn: 'show_entrance',
    support: [{type: 'android', version: '2.4.4'}]
  },
  invokeEntrance: {
    fn: 'share_slide_up',
    support: '2.4.4'
  },
  pageClose: {
    fn: 'page_close',
    support: '2.4.5'
  },
  getContact: {
    fn: 'readPhoneContact',
    support: [{type: 'android', version: '2.4.4'}]
  },
  withdrawCash: {
    fn: 'withdraw_cash',
    support: '2.4.4'
  },
  driverOut: {
    fn: 'driverOut',
    support: '2.4.5'
  },
  toMainPage: {
    fn: 'toMainPage',
    support: '2.4.4'
  },
  resizeImage: {
    fn: 'resizeImage',
    support: [{type: 'android', version: '2.4.4'}]
  },
  photograph: {
    fn: 'photograph',
    support: '2.4.4'
  },
  orderDetailInfo: {
    fn: 'orderDetailInfo',
    support: '2.4.4'
  },
  orderReassignState: {
    fn: 'orderReassignState',
    support: [{type: 'ios', version: '2.4.4'}]
  },
  checkOrderDetail: {
    fn: 'checkOrderDetail',
    support: '2.4.4'
  },
  getUserInfo: {
    fn: 'getUserInfo',
    support: '2.4.5',
    prepare: function(name, fn) {
      return['getUserInfo', {}, fn]
    }
  },
  getSystemInfo: {
    fn: 'getSystemInfo',
    support: '3.1.6',
    prepare: function(name, fn) {
      return['getSystemInfo', {}, fn]
    }
  },
  getLocationInfo: {
    fn: 'getLocationInfo',
    support: '2.4.4',
    prepare: function(name, fn) {
      return['getLocationInfo', {}, fn]
    }
  },
  launchNav: {
    fn: 'launchNav',
    support: '2.4.4',
  },
  launchScan: {
    fn: 'launchScan',
    support: '5.0.22',
  },
  openPage: {
    fn: 'openPage',
  },
  addCornerButton: {
    fn: 'addCornerButton',
    support: '2.5.2',
    prepare: function(name, params, fn) {
      //重置回调名，避免覆盖的可能
      var jsCall = "" + params.jsCallback + new Date().getTime()
      params.jsCallback = jsCall
      if(isIOS) {
        window.DidiJSBridge && DidiJSBridge.registerHandler(jsCall, fn)
      } else if(isAndroid) {
        window[jsCall] = fn
      }
      return['addCornerButton', params, function() {}]
    }
  },
  resetBack: {
    fn: 'resetBack',
    support: '2.6.0'
  }
}

export const daijiaConfig = {
  jumpUrl: {
    fn: 'jumpUrl'
  }
}

export const financeConfig = {
  /**
   * 设置webview的标题
   */
  setTitle: {
    fn: 'setTitle'
  },
  /**
   * 打开新页面
   */
  openPage: {
    fn: 'setTitle'
  },
  /**
   * 关闭页面
   */
  closePage: {
    fn: 'closePage'
  },
  /**
   * 刷新页面
   */
  refreshPage: {
    fn: 'refreshPage'
  },
  /**
   * 唤起登陆
   */
  requestLogin: {
    fn: 'requestLogin'
  },
  /**
   * 获取系统信息
   */
  getSystemInfo: {
    fn: 'getSystemInfo'
  },
  /**
   * 获取用户信息
   */
  getUserInfo: {
    fn: 'getUserInfo'
  },
  /**
   * 获取地理位置信息
   */
  getLocationInfo: {
    fn: 'getLocationInfo'
  },
  /**
   * 人脸识别
   */
  faceRecognize: {
    fn: 'faceRecognize'
  },
  /**
   * 支付
   */
  openUniPay: {
    fn: 'openUniPay'
  },
}



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/config.js